var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-card',{staticClass:"view-superadmin"},[_c('div',{staticClass:"submit"},[_c('base-button',{on:{"validated":function($event){return _vm.createAccount()}}},[_vm._v(" "+_vm._s(_vm.$t('createAccount'))+" ")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }